import { useState } from "react";
import { api, formatApiError } from "@/lib/api";

export const NewsletterSignup = ({ variant = "inline", id = "newsletter" }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ status: "idle" });

  const submit = async (e) => {
    e.preventDefault();
    setState({ status: "busy" });
    try {
      const { data } = await api.post("/newsletter/subscribe", { email });
      setState({ status: data.status });
      setEmail("");
    } catch (err) {
      setState({ status: "error", error: formatApiError(err) });
    }
  };

  const boxed = variant === "boxed";
  const done = { pending: "Nearly there — check your inbox and click the link to confirm.", already_subscribed: "You're already subscribed. Thank you." }[state.status];

  return (
    <div className={boxed ? "border-t-2 border-[var(--ink)] bg-white p-6 sm:p-8" : ""} data-testid={`${id}-signup`}>
      <p className={boxed ? "font-display text-2xl font-semibold" : "meta mb-1"}>{boxed ? "Get new articles by email" : "Newsletter"}</p>
      <p className={`text-sm text-[var(--ink-2)] leading-relaxed ${boxed ? "mt-2" : "mt-2"}`}>
        One email when something new is published. No spam, unsubscribe any time.
      </p>
      {done ? (
        <p className="mt-4 font-ui text-sm text-[#1F5130]" data-testid={`${id}-success`}>{done}</p>
      ) : (
        <form onSubmit={submit} className="mt-4 flex flex-col sm:flex-row gap-2">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address" aria-label="Email address"
            className="flex-1 min-w-0 border border-[#CFCFCB] bg-white px-3 py-2.5 font-ui text-sm outline-none focus:border-[var(--ink)] transition-colors" data-testid={`${id}-email-input`} />
          <button type="submit" disabled={state.status === "busy"} className="font-ui text-sm px-5 py-2.5 bg-[var(--ink)] text-white hover:bg-[var(--accent)] transition-colors disabled:opacity-60" data-testid={`${id}-submit-button`}>
            {state.status === "busy" ? "Sending…" : "Subscribe"}
          </button>
        </form>
      )}
      {state.status === "error" && <p className="mt-2 font-ui text-sm text-[var(--accent)]" data-testid={`${id}-error`}>{state.error}</p>}
    </div>
  );
};
